import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const ContactService = {
  actions: {
    fetchAllContactQueries ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/queries',
          method: 'GET'
        })
          .then(resp => {
            const queries = resp.data.queries
            commit('api_success')
            resolve(resp)
            return queries
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchContactQuery ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/query/' + id,
          method: 'GET'
        })
          .then(resp => {
            const query = resp.data.query
            commit('api_success')
            resolve(resp)
            return query
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    addReplyToQuery ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/query/' + data.query_id,
          data: {comment: data.comment},
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
            return resp
          })
          .catch(err => {
            // dispatch('catchHandler')
            commit('api_error')
            reject(err)
          })
      })
    },
    deleteContactQuery ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/query/' + id,
          method: 'delete'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    }
  }
}

export default ContactService



// WEBPACK FOOTER //
// ./src/services/contactQueryService.js